
<td class="patient-name-wrapper">
  <msd-avatar [text]="initials" [src]="pictureUrl"></msd-avatar>
  <span class="patient-name btn-link desktop" (click)="onNameClick?.emit()">{{name}}</span>
  <span class="patient-name mobile">{{name}}</span>
  <span class="badge badge-transparent">Nouveau</span>
</td>
<td>{{ diaryCount }} {{ diaryCount > 1 ? 'nouveaux événements' : 'nouvel événement' }}</td>
<td class="date">{{ formattedLastDiary }}</td>
